import { getConditionalArray } from 'utils/data';

export const RunSnapshotStatId = {
  STEPS: 'steps',
  FIELDS_FILLED: 'fieldsFilled',
  TOOL_CALLS: 'toolCalls',
  GUIDELINE_LOOKUPS: 'guidelineLookups',
  DOCUMENTS_REVIEWED: 'documentsReviewed',
  RECORDS_UPDATED: 'recordsUpdated',
  RECORDS_READ: 'recordsRead',
  AGENTS_USED: 'agentsUsed',
  SKILLS_USED: 'skillsUsed',
  ELAPSED: 'elapsed',
};

// Each run-wide tool stat is honest about what it counts: a count is only ever
// shown when it is > 0, so an empty category (e.g. a run that read no
// guidelines) drops its row entirely rather than rendering a hollow "0".
const RUN_TOOL_STAT_DEFINITIONS = [
  { id: RunSnapshotStatId.TOOL_CALLS, label: 'Tool calls', getValue: stats => stats.toolCalls },
  {
    id: RunSnapshotStatId.GUIDELINE_LOOKUPS,
    label: 'Guideline lookups',
    getValue: stats => stats.guidelineLookups,
  },
  {
    id: RunSnapshotStatId.DOCUMENTS_REVIEWED,
    label: 'Documents reviewed',
    getValue: stats => stats.documentsReviewed,
  },
  {
    id: RunSnapshotStatId.RECORDS_UPDATED,
    label: 'Records updated',
    getValue: stats => stats.recordsUpdated,
  },
  {
    id: RunSnapshotStatId.RECORDS_READ,
    label: 'Records read',
    getValue: stats => stats.recordsRead,
  },
  {
    id: RunSnapshotStatId.AGENTS_USED,
    label: 'Agents used',
    getValue: stats => stats.agentsUsed,
  },
  {
    id: RunSnapshotStatId.SKILLS_USED,
    label: 'Skills used',
    getValue: stats => stats.skillsUsed,
  },
];

const getRunToolStats = stats =>
  RUN_TOOL_STAT_DEFINITIONS.flatMap(({ id, label, getValue }) => {
    const value = getValue(stats);

    return getConditionalArray(value > 0, () => [{ id, label, value: `${value}` }]);
  });

// "Fields filled" is only meaningful when the run carries a form whose schema has
// at least one field; an absent or empty form (fieldsTotal === 0) drops the stat
// rather than rendering a hollow "0 / 0".
export const getRunSnapshotStats = ({
  completed,
  total,
  elapsedLabel,
  fieldsFilled,
  fieldsTotal,
  toolCalls,
  guidelineLookups,
  documentsReviewed,
  recordsUpdated,
  recordsRead,
  agentsUsed,
  skillsUsed,
}) => [
  { id: RunSnapshotStatId.STEPS, label: 'Steps', value: `${completed} / ${total}` },
  ...getConditionalArray(fieldsTotal > 0, () => [
    {
      id: RunSnapshotStatId.FIELDS_FILLED,
      label: 'Fields filled',
      value: `${fieldsFilled} / ${fieldsTotal}`,
    },
  ]),
  ...getRunToolStats({
    toolCalls,
    guidelineLookups,
    documentsReviewed,
    recordsUpdated,
    recordsRead,
    agentsUsed,
    skillsUsed,
  }),
  { id: RunSnapshotStatId.ELAPSED, label: 'Elapsed', value: elapsedLabel },
];
